
import { component } from '@/helpers/vueTyped';

export default component()({
  name: 'ContentCardGhostLoader',

  functional: true,

  render(h, context) {
    return (
      <div
        class='container'
        ref={context.data.ref}
        on={context.listeners}
        {...{ directives: context.data.directives }}
      >
        <div class='card mask' />
        <div class='title mask' />
        <div class='subtitle mask' />
      </div>
    );
  },
});

// VUE JSX HOT LOADER //
if (module.hot) require("/github/workspace/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-37ed3ce2/ContentCardGhostLoader.vue" });